import React, { Component } from "react";
import { API } from "aws-amplify";
import { Form } from "react-bootstrap";
import { Formik } from 'formik';
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";
import { Button } from "react-bootstrap";
import "./UnregisterEmail.css";

export default class UnregisterEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      userId: "",
      isDeletingUser: false,
      alertMessage: ""
    };

    if (props.location.state) {
      localStorage.setItem('unregisterUserId',props.location.state.UserId);
      localStorage.setItem('unregisterEmail',props.location.state.Email);
      this.state.email = props.location.state.Email;
      this.state.userId = props.location.state.UserId;
    }
    else {
      this.state.userId = localStorage.getItem('unregisterUserId');
      this.state.email = localStorage.getItem('unregisterEmail');
    }

  }

  handleSubmit = async event => {
    this.setState({ isDeletingUser: true, alertMessage: "" });
    try {
      let post = { body: { userid: this.state.userId }}
      await API.post("license", "/delete-user", post);
      this.setState({ isDeletingUser: false });
      this.props.history.goBack();
    } catch (e) {
      this.setState({ alertMessage: e.message});
      this.setState({ isDeletingUser: false });
    }
  };

  renderForm() {
    return (
      <div className="login">
      <Formik
      validateOnChange={false}
      onSubmit={this.handleSubmit}
      validator={() => ({})}
      initialValues={{
        Email: this.state.email
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
      <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <div className="content">
          <h2>Unregister User</h2>
          <div>Use this form to unregister and remove users from your list of licensed users.</div>
          <div>If you cannot remove a user please contact <a href = "mailto: sales@absolute.technology">sales@absolute.technology</a></div>
        </div>
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control className="form-control-sm"
              name="Email"
              value={values.Email}
              type="email"
              readOnly={true}
              onChange={handleChange}
              isInvalid={!!errors.Email}
            />
            <Form.Control.Feedback type="invalid">
                {errors.Email}
            </Form.Control.Feedback>
          </Form.Group>
        <LoaderButton
          span
          type="submit"
          bsSize="large"
          text="Unregister Email"
          loadingText="Deleting…"
          isLoading={this.state.isDeletingUser} />
          <Button onClick={() => this.props.history.goBack()} className="float-right btn btn-primary btn-dark btn-sm" disabled={this.state.isDeletingUser}>
            Cancel
          </Button>
        </Form>
      </div>
       )}
      </Formik>
      </div>
    );
  }

  render() {
    return (
      <div className="main">
      {this.renderForm()}
    </div>
    );
  }
}
